import ApiService from '../common/api.service'
import {
  GETORDERLIST, GETORDERBYYID, GETORDERPACKAGELISTBYORDERID,
  GETSECTIONSBYTEMPLATEID, PATCHORDER, UPLOADPACKAGE, ADDORDERPACKAGE,
  GETPACKAGECATEGORIESLIST, DELETEPACKAGE, DASHBOARDREPORT, GETORDERLISTBYSTATUS,
  GETORDERLISTBYCLIENTREF, ADDORDER, UPDATEORDER, PATCHPACKAGE, PATCHORDERPACKAGE,
  GETORDERLISTBYHOLD, ADDORDERFIELDDATA, UPDATEORDERFIELDDATA, GETSECTIONSDATABYORDERID,
  CREATEFINALPACKAGE, GETFINALPACKAGE, GETCLIENTLIST, GETPRODUCTLIST, GETSTATELIST,
  GETCOUNTYLIST, GETVENDORLIST, GETORDERSTATUSLIST, GETSEARCHORDER, SORTALLORDERPACKAGES, GETORDERRUNSHEET, GETTAXHUBDATA,
  GETCLIENTPRODUCTFEES, ADDVENDORTOORDER, ADDUSERSTOORDER, ADDVENDORTOUSERS, REMOVEUSERFROMORDER, GETSEARCHUSER,
  GETORDERETASBYYORDERID, ADDORDERETA, DOWNLOADDTDOC, PATCHORDERSHEET, SAVEORDERRUNSHEET,
  GETDOCUMENTREASONS, ADDDOCUMENTSELECTIONS, GETDOCUMENTSELECTIONS, GETSCRAPPEDRUNSHEETDATA,
  GETRUNSHEETSCRAPPINGSTATUS, TRIGGERRUNSHEETSCRAPPING, GETORDERLISTBYHOLD_V2, GETORDERLISTBYSTATUS_V2, GETORDERLISTBYCLIENTREF_V2,
  GETORDERLIST_V2, GETSEARCHORDER_V2
} from './actions.type'
import { SET_ORDERLIST, SET_ERROR } from './mutations.type'

// Helper function to handle API errors consistently
const handleApiError = (context, response) => {
  console.log(response)
  if (response.status === 401) {
    const errorMessage = response.data.detail
    if (errorMessage === 'Token has expired' || errorMessage === 'Invalid token.') {
      context.commit(SET_ERROR, response)
      localStorage.removeItem('ID_TOKEN_KEY')
      window.location.href = '/login'
      return Promise.reject(response)
    }
  }
  context.commit(SET_ERROR, response)
  return Promise.reject(response)
}

const state = {
  errors: null,
  orderList: [],
  errorMessage: null,
  errorType: null
}

const getters = {
  orderList () {
    return state.orderList
  },
  error (state) {
    return state.error
  },
  errorMessage (state) {
    return state.errorMessage
  },
  errorType (state) {
    return state.errorType
  }
}

const actions = {
  [GETORDERLIST] (context) {
    ApiService.setHeader()
    return ApiService.get('orders')
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLIST_V2] (context) {
    ApiService.setHeader()
    return ApiService.get('v2/orders')
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETFINALPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_final_packages', `?order__id=${payload.order__id}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYHOLD] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('orders', `?on_hold=${payload.on_hold}&page=${payload.page}&page_size=${payload.itemsPerPage}`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYHOLD_V2] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('v2/orders', `?on_hold=${payload.on_hold}&page=${payload.page}&page_size=${payload.itemsPerPage}`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYSTATUS] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('orders', `?status__name__in=${payload.status__name__in}&page=${payload.page}&page_size=${payload.itemsPerPage}`)
      .then(({ data }) => {
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYSTATUS_V2] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('v2/orders', `?status__name__in=${payload.status__name__in}&page=${payload.page}&page_size=${payload.itemsPerPage}`)
      .then(({ data }) => {
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYCLIENTREF] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('orders', `?client_reference__contains=${payload.client_reference}`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERLISTBYCLIENTREF_V2] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('v2/orders', `?client_reference__contains=${payload.client_reference}`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERBYYID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get(`orders`, `${payload.id}`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [PATCHORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.patch(`orders/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [PATCHORDERSHEET] (context, payload) {
    ApiService.setHeader()
    return ApiService.patch(`order_run_sheet/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [UPDATEORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.put(`orders/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [SORTALLORDERPACKAGES] (context, payload) {
    ApiService.setHeader()
    return ApiService.get(`sort_packages`, `${payload.id}`)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERPACKAGELISTBYORDERID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_packages', `?order__id=${payload.order__id}&page_size=10000`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [UPDATEORDERFIELDDATA] (context, payload) {
    ApiService.setHeader()
    return ApiService.put(`order_field_data/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDORDERFIELDDATA] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('order_field_data/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDVENDORTOORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('assign_vendor_to_orders/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDUSERSTOORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('assign_users_to_orders/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [CREATEFINALPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('order_final_packages/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [REMOVEUSERFROMORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('remove_user_from_orders/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDVENDORTOUSERS] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('assign_vendor_to_users/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSECTIONSBYTEMPLATEID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('template_sections', `?template__id=${payload.template__id}`)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSECTIONSDATABYORDERID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_field_data', `?order__id=${payload.order__id}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [UPLOADPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('packages/', payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [PATCHPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.patch(`packages/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [PATCHORDERPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.patch(`order_packages/${payload.id}/`, payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDORDERPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('order_packages/', payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDORDER] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('orders/', payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETPACKAGECATEGORIESLIST] (context) {
    ApiService.setHeader()
    return ApiService.get('package_categories')
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [DELETEPACKAGE] (context, payload) {
    ApiService.setHeader()
    return ApiService.delete(`order_packages/${payload.id}/`)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [DASHBOARDREPORT] (context) {
    ApiService.setHeader()
    return ApiService.get(`dashboard_report`)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETCLIENTLIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`clients`, `?page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETPRODUCTLIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`products`, `?page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSTATELIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`states`, `?page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETCOUNTYLIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`counties`, `?page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETVENDORLIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`vendors`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERSTATUSLIST] (context) {
    ApiService.setHeader()
    return ApiService.get(`order_statuses`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSEARCHORDER] (context, payload) {
    payload = decodeURI(payload)
    console.log(payload)
    ApiService.setHeader()
    return ApiService.get(`orders`, `?${payload}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSEARCHORDER_V2] (context, payload) {
    payload = decodeURI(payload)
    console.log(payload)
    ApiService.setHeader()
    return ApiService.get(`v2/orders`, `?${payload}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERRUNSHEET] (context, payload) {
    payload = decodeURI(payload)
    console.log(payload)
    ApiService.setHeader()
    return ApiService.get(`order_run_sheet`, `?${payload}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [SAVEORDERRUNSHEET] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('create_final_run_sheet/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETTAXHUBDATA] (context, payload) {
    payload = decodeURI(payload)
    console.log(payload)
    ApiService.setHeader()
    return ApiService.get(`tax_hub_data`, `?${payload}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSEARCHUSER] (context, payload) {
    payload = decodeURI(payload)
    console.log(payload)
    ApiService.setHeader()
    return ApiService.get(`users`, `?${payload}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETCLIENTPRODUCTFEES] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('client_fees', `?client__id=${payload.client__id}&product__id=${payload.product__id}&state__id=${payload.state__id}&county__id=${payload.county__id}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETORDERETASBYYORDERID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_etas', `?order__id=${payload.order__id}&page=${payload.page}&page_size=${payload.itemsPerPage}`)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDORDERETA] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('order_etas/', payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [DOWNLOADDTDOC] (context, payload) {
    ApiService.setHeader()
    return ApiService.post(`download_dt_doc/`, payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETDOCUMENTREASONS] (context) {
    ApiService.setHeader()
    return ApiService.get('order_run_sheet_document_codes')
      .then(({ data }) => {
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [ADDDOCUMENTSELECTIONS] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('order_run_sheet_doc_data/', payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETSCRAPPEDRUNSHEETDATA] (context, payload) {
    const { orderId, siteType, dataType } = payload
    ApiService.setHeader()
    return ApiService.get(`tax‑assessor/?order=${orderId}&site_type=${siteType}&page=1&page_size=1000${dataType ? `&data_type=${dataType}` : ''}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETDOCUMENTSELECTIONS] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_run_sheet_doc_data', `?order_run_sheet_id=${payload.order_run_sheet_id}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [GETRUNSHEETSCRAPPINGSTATUS] (context, payload) {
    const { orderId } = payload
    ApiService.setHeader()
    return ApiService.get(`re_run_dag/get_dag_status/?order_id=${orderId}`)
      .then(({ data }) => {
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [TRIGGERRUNSHEETSCRAPPING] (context, payload) {
    const { orderId, parcelId } = payload
    ApiService.setHeader()
    return ApiService.post(`re_run_dag/`, {
      order_id: orderId,
      ...(parcelId ? {
        parcel_id: parcelId
      } : {})
    })
      .then(({ data }) => {
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error.data
    state.errorMessage = error.data
    state.errorType = error.status + ': ' + error.statusText
  },
  [SET_ORDERLIST] (state, orderList) {
    state.orderList = orderList
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
